PricingBI.vue<template>
	<v-row no-gutters>
		<v-col cols="12">
      <iframe
        title="BI Redistribuição Estoque"
        style="height:80vh; width:100%"
        src="https://app.powerbi.com/view?r=eyJrIjoiNDFhZjMzZTgtMzM4MS00YzgzLTg1ZjUtYmU3YjBjZGI4YzkxIiwidCI6ImYxZGJlOWZhLWZkNTktNDMzZS04Y2RjLTI4ODRmZDgyYmRhNSJ9"
        frameborder="0"
        allowfullscreen="true"
      ></iframe>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "EstoqueBI",
	components: {},
	data: () => ({
		tab: 0,
	}),
	computed: {},
	methods: {
		async init() {},
	},
	created() {
		this.init();
	},
};
</script>